module.exports = __webpack_public_path__ + "img/user.05adfbbe.png";